const errorRedirectAddress = '404'
export const generateAddBundleToCartHref = (products, checkedProductIds) => {
  if (!Array.isArray(products) || products.length === 0) return errorRedirectAddress
  const checkedProducts = Array.isArray(checkedProductIds)
    ? products.filter(product => checkedProductIds.includes(product?.id))
    : products

  const productsSerialized = checkedProducts
    .map(({ id, offerId } = {}) => {
      if (!id) return undefined
      return offerId ? `${id}o${offerId}` : id
    })
    .filter(Boolean)
    .join('_')
  if (productsSerialized.length === 0) return errorRedirectAddress
  return `/cart/add/${productsSerialized}`
}

export const updateCheckedProducts = (productIds, selectedProductId) => {
  if (productIds.includes(selectedProductId)) {
    return productIds.filter(id => id !== selectedProductId)
  }
  return [...productIds, selectedProductId]
}
